import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users/users.service';
import { lastValueFrom } from 'rxjs';
import { Error } from 'src/app/models/error.model';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { UserInfo } from 'src/app/models/user-info.model';

@Component({
  selector: 'app-avs-update-validation-dialog',
  templateUrl: './avs-update-validation.component.html',
  styleUrls: ['./avs-update-validation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UserAvsUpdateValidationComponent {
  updatedUserForm: FormGroup;
  isBusy: boolean;
  isUserUpdated: boolean;
  isErrorUpdateUser: boolean;
  errorUpdateUser: Error;
  updatedUser: UserInfo;
  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };
  constructor(
    public matDialogRef: MatDialogRef<UserAvsUpdateValidationComponent>,
    @Inject(MAT_DIALOG_DATA)
    _data: { updatedUserFields; updatedUser: UserInfo },
    private _userService: UsersService
  ) {
    this.updatedUserForm = new FormGroup(_data.updatedUserFields);
    this.updatedUserForm.disable();

    this.updatedUser = _data.updatedUser;
  }

  getLabelForControl(controlName: string): string {
    const labels = {
      avs: 'USER.AVS-CONFIRM.AVS',
      officialFirstName: 'USER.AVS-CONFIRM.OFFICIALNAME',
      officialLastName: 'USER.AVS-CONFIRM.OFFICIALLASTNAME',
      firstName: 'USER.AVS-CONFIRM.FIRSTNAME',
      lastName: 'USER.AVS-CONFIRM.LASTNAME',
      eduvsMail: 'USER.AVS-CONFIRM.EDUVSMAIL',
      eduvsLogin: 'USER.AVS-CONFIRM.EDUVSLOGIN',
      dateOfBirth: 'USER.AVS-CONFIRM.DATEOFBIRTH',
      gender: 'USER.AVS-CONFIRM.GENDER',
    };
    return labels[controlName] || controlName;
  }

  async updateUserInfo() {
    this.isBusy = true;
    this.isUserUpdated = false;
    this.isErrorUpdateUser = false;
    try {
      await lastValueFrom(
        this._userService.changeAvsInfo(this.updatedUser)
      ).then(() => {
        this.isUserUpdated = true;
        this.isErrorUpdateUser = false;
      });
    } catch (error) {
      let customError: Error = { error: undefined };
      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.status === 400) {
          customError = { error: { message: 'Unknown Error', code: 'ERR19' } };
        }
        if (error.status === 500) {
          customError = { error: { message: 'Unknown Error', code: 'ERR29' } };
        }
      }

      this.isErrorUpdateUser = true;
      this.errorUpdateUser = customError;
      this.isUserUpdated = false;
    } finally {
      this.isBusy = false;
    }
  }

  // Méthode pour obtenir les noms des contrôles de formulaire
  get updatedUserFormControls() {
    return Object.keys(this.updatedUserForm.controls);
  }

  // Méthode pour obtenir les noms des contrôles de formulaire
  getUpdatedUserFormValue(controlName: string): string {
    return this.updatedUserForm.get(controlName).value;
  }
}
